<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
  <div v-if="loading" class="loading">
    <!-- loading progress circle 추가 -->
    <v-progress-circular
      indeterminate
      color="white"
    ></v-progress-circular>
  </div>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    loading: false,
    config : {
      headers: {
        'Authorization': '',
      }
    },
    user : {},
  }),
  methods: {
    
  },
  mounted() {
    // session storage에서 token을 가져와서 config에 저장
    this.config.headers.Authorization = 'Bearer ' + sessionStorage.getItem('token');
    document.title = '법무관리플랫폼';
  }
}
</script>

<style>
@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard-gov.min.css");
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+KR:wght@400;700&display=swap');

body, html {
    /* 배경 흰색으로 고정 */
    background-color: #ffffff !important;
}

/* 변수 선언 */
:root {
    --app-width: 700px;
    --main-button-color: #B84A5B;
    --app-mobile-padding: 10px;
    --app-desktop-padding: 10px;

    --side-menu-width: 0px;
    --toolbar-height : 50px;
    --margin-5 : 5px;
    --margin-10 : 10px;
    --margin-20 : 20px;
    --margin-30 : 30px;
    --margin-40 : 40px;
    --margin-50 : 50px;
    --margin-60 : 60px;
    --margin-70 : 70px;
    --margin-80 : 80px;
    --margin-90 : 90px;
    --margin-100 : 100px;
    --primary-color: #2A2B2D;
    --secondary-color: #0088EA;
    --warning-color: #6C2831;
    --success-color: #00637C;
    --info-color: #3A5589;
    --danger-color: #6C2831;
    --verify-color: #D6C69A;
}

.v-navigation-drawer {
    font-family: "Pretendard GOV Variable", "Pretendard GOV", -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif !important;    
}

.v-app, .v-main {
    background-color: #ffffff !important;
}

.v-container {
    font-family: "Pretendard GOV Variable", "Pretendard GOV", -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif !important;    
    background-color: #ffffff !important;
}

div {
    font-family: "Pretendard GOV Variable", "Pretendard GOV", -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif !important;    
}

.color-primary {
    background-color: var(--primary-color) !important;
    color: #fff !important;
}
.color-secondary {
    background-color: var(--secondary-color) !important;
    color: #fff !important;
}
.color-warning {
    background-color: var(--warning-color) !important;
    color: #fff !important;
}
.color-success {
    background-color: var(--success-color) !important;
    color: #fff !important;
}
.color-info {
    background-color: var(--info-color) !important;
    color: #fff !important;
}
.color-danger {
    background-color: var(--danger-color) !important;
    color: #fff !important;
}
.color-verify {
    background-color: var(--verify-color) !important;
    color: #000;
}
.underline {
    /* 2px로 아래 밑줄 */
    border-bottom: 3px solid var(--primary-color);
}

.ibm-plex-sans-kr-regular {
  font-family: "IBM Plex Sans KR", sans-serif !important;
  font-weight: 400;
  font-style: normal;
}
.ibm-plex-sans-kr-bold {
  font-family: "IBM Plex Sans KR", sans-serif !important;
  font-weight: 700;
  font-style: normal;
}

.v-container.mobile-app {
    max-width: var(--app-width) !important;
    font-family: "Pretendard GOV Variable", "Pretendard GOV", -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif !important;    
    height : calc(100% - 40px);

    /* 그림자효과 */
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    border-radius: 20px;
    padding-top: var(--app-desktop-padding) !important;
    padding-left : var(--app-desktop-padding) !important;
    padding-right : var(--app-desktop-padding) !important;
    margin-top : 20px;
    max-height: calc(100% - 200px);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    /* 스크롤바 */
    overflow-y: auto;
    scrollbar-width: none;
    

}

.v-dialog {
    border-radius: 20px;    
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    font-family: "Pretendard GOV Variable", "Pretendard GOV", -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif !important;    
}


h1, h2, h3 {
    font-weight: 700;
    letter-spacing: -1px;
}
button.calc-button {
    height:50px !important;
    border-radius: 15px !important;
    position: fixed;
    bottom: 30px;
    left : 50%;
    transform: translateX(-50%);
    margin: 0 auto;
    margin-bottom : 10px;
    width : 100px;
    max-width: var(--app-width);
    width: 100%;
    font-size: 16px;
    font-size : 18px !important;
    height: 60px !important;
    border-radius: 25px !important;
    background-color: var(--secondary-color) !important;
    max-width: calc(var(--app-width) - var(--app-desktop-padding) * 2);  

}

.v-text-field .v-text-field__details {
    display: none;
}

.v-select .v-input__control {
    height: 62px !important;
}

p.hint {
    font-size : 13px;
    color: #666;
}

.logo {
    width: 80px;
}

.big-number {
    color : var(--secondary-color);
    font-size : 30px;
    border-bottom: 3px solid var(--secondary-color);    
}

.small-number {
    color : var(--primary-color);
    font-size : 25px;
    /* border-bottom: 3px solid var(--primary-color); */
}

/* 모바일 */
@media screen and (max-width: 600px) {
    .v-container.mobile-app {
        margin-top : 0; 
        max-height: 100% !important;
        border-radius: 0px;
        padding-left : var(--app-mobile-padding) !important;
        padding-right : var(--app-mobile-padding) !important;
        padding-top : var(--app-mobile-padding) !important;
        height: 100%;
        background-color: #f5f5f5 !important;
        margin-bottom : 0px !important;
    }
    
    button.calc-button {        
        bottom : 10px;
        max-width : calc(100% - 30px);

    }
}

.v-container.full-width {
    max-width: 100% !important;
    padding-left : 50px !important;
    padding-top : 25px !important;
    background-color: #f5f5f5 !important;
    height: 100% !important;
}

.handsontable {
    font-family: "Pretendard GOV Variable", "Pretendard GOV", -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif !important;    
}

.card {
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 0px 0 rgba(0, 0, 0, 0) !important;
    /* box-shadow: none; */
}


.v-select .v-input__control {
    height:48px !important;
}

div.bottom-button {
  max-width : 700px !important;
  font-family: "Pretendard GOV Variable", "Pretendard GOV", -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif !important;
  position: fixed !important;
  bottom: 40px !important;
  /* padding-bottom:40px !important; */
  width: calc(700px) !important;    
  /* 가운데 위치 */
  left: 50%;
  transform: translateX(-50%);
  background-color: white !important;
  z-index: 1000;
}

/* 모바일 설정 */
@media (max-width: 600px) {
  div.bottom-button {
    bottom : 0px !important;
    padding-bottom: 10px !important;
    width: calc(100% - 30px) !important;
  }
}

.loading {
    /* 전체화면 흐리게 */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    /* blur 효과 */
    backdrop-filter: blur(5px);

    /* 화면 가운데 위치 */
    display: flex;
    justify-content: center;
    align-items: center;

}

.v-checkbox label {
    margin-left : 5px !important;
}

.bottom-fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: white;
    padding-bottom: 30px;
    padding-top : 10px;
    /* box-shadow: 0 0 20px rgba(0, 0, 0, 0.2); */
    /* blur 처리 */
    backdrop-filter: blur(5px);
    z-index: 1000;
}
@media (min-width: 600px) {
    .bottom-fixed {
        padding: 50px 0;
    }
}

.v-btn.checked {
    background-color: #56b8ff;
    color: white;
}

.v-btn.unchecked {
    background-color: #ffffff;
    color: rgb(136, 136, 136);
}

p.hint {
    font-size : 14px;
    color: #666;
}

.section-divider {    
    min-height: 10px;
    background-color: #f5f5f5;
    margin: 30px 0;
    position: relative;
    
}

@media screen and (max-width: 600px) {
    .section-divider {
        width: 100vw;
        left: 50%;
        right: 50%;    
        margin-left: -50vw;
        margin-right: -50vw;
    }
    
}
</style>